import React, { useEffect, useRef } from "react"

/**
 * FilmModal — lecteur plein écran d'un film officiel (vidéo hébergée, son, contrôles).
 * La vidéo n'est montée qu'à l'ouverture. Échap ou clic hors du lecteur ferment,
 * le défilement est bloqué, le focus revient au bouton qui a ouvert.
 */
const FilmModal = ({ open, onClose, src, poster, title, closeLabel = "Fermer" }) => {
  const closeRef = useRef(null)
  const videoRef = useRef(null)
  const openerRef = useRef(null)
  const onCloseRef = useRef(onClose)
  onCloseRef.current = onClose

  useEffect(() => {
    if (!open) return undefined
    openerRef.current = document.activeElement
    const prevOverflow = document.body.style.overflow
    document.body.style.overflow = "hidden"
    if (closeRef.current) closeRef.current.focus()
    const v = videoRef.current
    if (v) {
      const p = v.play()
      if (p && typeof p.catch === "function") p.catch(() => {})
    }
    const onKey = e => {
      if (e.key === "Escape") { e.preventDefault(); onCloseRef.current() }
      if (e.key === "Tab") {
        const f = [closeRef.current, videoRef.current].filter(Boolean)
        const i = f.indexOf(document.activeElement)
        if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus() }
        else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus() }
      }
    }
    document.addEventListener("keydown", onKey)
    return () => {
      document.removeEventListener("keydown", onKey)
      document.body.style.overflow = prevOverflow
      const o = openerRef.current
      if (o && typeof o.focus === "function") o.focus()
    }
  }, [open])

  if (!open) return null
  return (
    <div
      className="fm-backdrop"
      onClick={e => { if (e.target === e.currentTarget) onClose() }}
      style={{ position: "fixed", inset: 0, zIndex: 10000, background: "rgba(0,0,0,0.88)", display: "flex", alignItems: "center", justifyContent: "center", padding: "56px 16px 24px", boxSizing: "border-box" }}
    >
      <div role="dialog" aria-modal="true" aria-label={title} style={{ position: "relative", width: "100%", maxWidth: 1200 }}>
        <button
          ref={closeRef}
          type="button"
          onClick={onClose}
          aria-label={closeLabel}
          style={{ position: "absolute", top: -48, right: 0, width: 40, height: 40, borderRadius: "50%", border: "none", background: "rgba(255,255,255,0.16)", color: "#fff", fontSize: 18, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
        >✕</button>
        <video
          ref={videoRef}
          src={src}
          poster={poster}
          controls
          playsInline
          preload="metadata"
          aria-label={title}
          style={{ display: "block", width: "100%", maxHeight: "calc(100svh - 96px)", aspectRatio: "16 / 9", background: "#000", borderRadius: 18, outline: "none" }}
        />
      </div>
    </div>
  )
}

export default FilmModal
